import ShowcaseGroupContent from '../ShowcaseGroupContent';
import ShowcaseSingleContent from '../ShowcaseSingleContent';

interface Props {
  // type: 'showcase_group' | 'showcase';
  type: string;
  // displayType: 'grid_2x2' | 'grid_3x2' | 'list_1x3' | 'carousel_1x10';
  displayType: string;
  code: string;
}

const ShowcaseRenderer = ({ type, displayType, code }: Props) => {
  return (
    <section className="p-20">
      {type === 'showcase_group' ? (
        <ShowcaseGroupContent displayType={displayType} code={code} />
      ) : (
        <ShowcaseSingleContent displayType={displayType} code={code} />
      )}
    </section>
  );
};

export default ShowcaseRenderer;
